import { useNavigate } from "react-router-dom";
import { CtaButton } from "../Buttons";
import { useSelector } from "react-redux";
import { getPath, getTranslations } from "../../Common/utils";
import {
  CREATE_LEAGUE,
  MAX_LEAGUE_NAME_CHARACTERS,
  MIN_LEAGUE_NAME_CHARACTERS,
} from "../../Common/constants";

const SubmitCTAs = ({
  isEdit = false,
  submitEditLeagueData,
  editLeagueConfirmState,
}) => {
  const navigate = useNavigate();
  const translationState = useSelector((state) => state.translation);
  const { createLeagueData } = useSelector((state) => state.league);

  const canCreateLeague = () => {
    let isValid = true;
    for (const key in createLeagueData) {
      if (Object.hasOwnProperty.call(createLeagueData, key)) {
        const element = createLeagueData[key];
        if (
          key === "leagueName" &&
          (!element.trim() ||
            element.trim().length < MIN_LEAGUE_NAME_CHARACTERS ||
            element.trim().length > MAX_LEAGUE_NAME_CHARACTERS)
        ) {
          isValid = false;
        } else if (
          key === "maxParticipants" &&
          createLeagueData?.leagueType !== "h2h" &&
          element < 5
        ) {
          isValid = false;
        } else if (!element) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const handleSelectTeams = () => {
    //   pushSelectTeamsAndCancelDataLayer("SELECT_TEAMS");
    console.log("handleSelectTeams is called");
    console.log(
      "getPath(translationState, 'leagueSelectTeam')",
      getPath(translationState, "leagueSelectTeam")
    );
    navigate(getPath(translationState, "leagueSelectTeam"), {
      state: {
        type: CREATE_LEAGUE,
      },
      // replace: true,
    });
  };

  const handleDiscard = () => {
    // navigate to leagues page
    navigate(getPath(translationState, "leagues"));
  };

  if (isEdit) {
    return (
      <CtaButton
        children={getTranslations(
          "update_league_confirm_changes",
          "Confirm Changes"
        )}
        icon="f1i-ar-right"
        onClick={() => submitEditLeagueData(createLeagueData)}
        variant={"accent"}
        disabled={editLeagueConfirmState}
      />
    );
  }

  return (
    <>
      <CtaButton
        children={getTranslations(
          "create_league_select_teams_cta",
          "Select Teams"
        )}
        icon="f1i-ar-right"
        onClick={handleSelectTeams}
        variant={"accent"}
        disabled={!canCreateLeague()}
      />
      <CtaButton
        children={getTranslations("create_league_discard_cta", "Discard")}
        onClick={handleDiscard}
        variant={"primaryLight"}
        icon={"f1i-delete"}
        leadingIcon={true}
      />
    </>
  );
};

export { SubmitCTAs };
